/** student/roles — HOOKS. Static reference data → cached indefinitely. */
import { useQuery } from '@tanstack/react-query';
import { studentRolesApi } from './api';
import { studentRolesKeys } from './keys';

export function useRoles() {
  return useQuery({
    queryKey: studentRolesKeys.all(),
    queryFn: () => studentRolesApi.list(),
    staleTime: Infinity,
  });
}
